import {h, Component} from 'preact';
import fetch from 'unfetch'
import { Link } from 'preact-router/match';

const TOURDATA = 'https://kennymason.airplug.io/catalog.json';
// https://russ-catalog.airplug.io/latest.json
// https://api.airtable.com/v0/app4bpp7Je97fEZy9/catalog?api_key=keyZ90pUeAECN3cs0
export default class Latest extends Component {
	componentDidMount() {
		fetch(TOURDATA).then(r => r.json()).then(resp => {
			const futureRecords = resp.records.filter(record => record.fields.is == true)
			this.setState({records: futureRecords});
		});
	}
	render({}, {
		records = []
	}) {
		return (
			<div className="page page__tour">
					<Link href="/">
  <div class="marquee shop">
    <span>

	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 BUY THE MERCH <i class="middot">·</i>   
	 

	  </span>
  </div>
  </Link>
  <div class="clearfix"></div>
				{records
					? (
						<div class="list">
          
                                 {records.map(song => (<Song song={song}/>))} 
                     
	<div class="clearfix"></div>
  <br/>
						</div>
					)
					: (<progress-spinner style="font-size:50px; position:absolute; top:50%; left:50%; margin:-25px 0 0 -25px;"/>)}
          
			</div>
		);
	}
}
const Song = ({song}) => (
	<div class="songsong">
        
	
<div class="songContain">
	 <h3>{song.fields.Title} </h3> 
	 <h3><img src={song.fields.cover} /> </h3> 
	<div class="songLinks">
		<div>{song.fields.spotify && 	<a href={song.fields.spotify} target="_blank">spotify</a> }</div> 
		<div>{song.fields.apple && 	<a href={song.fields.apple} target="_blank">apple</a> }</div> 
		<div>{song.fields.youtube && 	<a href={song.fields.youtube} target="_blank">Youtube</a> }</div> 
		<div>{song.fields.itunes && 	<a href={song.fields.itunes} target="_blank">itunes</a> }</div> 
		<div>{song.fields.soundcloud && <a href={song.fields.soundcloud} target="_blank">Soundcloud</a> }</div> 
		<div>{song.fields.deezer && 	<a href={song.fields.deezer} target="_blank">Deezer</a> }</div> 
		<div>{song.fields.tidal && 	<a href={song.fields.tidal} target="_blank">Tidal</a> }</div> 
		<div>{song.fields.pandora && 	<a href={song.fields.pandora} target="_blank">pandora</a> }</div> 
		<div>{song.fields.amazon && 	<a href={song.fields.amazon} target="_blank">Amazon</a> }</div> 
		<div>{song.fields.audiomack && 	<a href={song.fields.audiomack} target="_blank">audiomack</a> }</div> 

		</div>
		</div>
		
	<div class="clearfix"></div>
			
	</div>
);



// WEBPACK FOOTER //
// ./routes/listen/index.js